import { useContext } from 'react';

import { PlayerTrackerContext } from '../../ui/player-tracker/context';

export const useTrackerContext = () => useContext(PlayerTrackerContext);
